<template>
  <v-select
    dusk="tipo-usuario-select"
    v-model="model"
    placeholder="Selecione"
    class="w-full select-large bg-white tipo-usuario-select"
    value="id"
    label="nome"
    :name="name"
    :clearable="clearable"
    :disabled="disabled"
    :readonly="readonly"
    :options="options"
    @input="$emit('input', model)"
  />
</template>

<script>
import vSelect from "vue-select";

export default {
  name: "tipo-usuario-select",
  components: { vSelect },
  props: {
    value: { default: null },
    name: { type: String, default: null },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    clearable: { type: Boolean, default: false }
  },
  data: () => {
    return {
      model: null
    };
  },
  created() {
    this.$store.dispatch("FETCH_TIPO_USUARIO");
    this.model = this.value;
  },
  watch: {
    value(value) {
      this.model = value;
    }
  },
  computed: {
    options() {
      return this.$store.getters.getTiposUsuario();
    }
  }
};
</script>
